// This allows us to load it independently for specific files in separate bundles
// without introducing multiple Backbone instances in the main app bundle

let Backbone = typeof window !== "undefined" ? window.Backbone : null;

if (!Backbone) {
    Backbone = require("backbone");
}

export { Backbone };
